import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function useAPLPeriodData(periodsData, level, objId) {
  const [period, setPeriod] = useState(null);
  const [activePeriodId, setActivePeriodId] = useState(null);
  const [periodsToSelect, setPeriodsToSelect] = useState([]);
  const [currentPeriods, setCurrentPeriods] = useState(null);
  const periodIdRef = useRef(null);
  const navReducer = useSelector((state) => state.teacherTabNavReducer);

  // Effect for setting period based on navReducer selection
  useEffect(() => {
    if (
      !periodsData.isLoading &&
      periodsData.data &&
      periodsData.data.some(
        (prd) => prd.period.id === navReducer.selectedAplPeriodId
      )
    ) {
      const tempPeriod = periodsData.data.find(
        (prd) => prd.period.id === navReducer.selectedAplPeriodId
      );

      // Deep clone to avoid mutation issues
      const clonedPeriod = structuredClone(tempPeriod);

      if (level === "Student") {
        clonedPeriod.period.students = clonedPeriod.period.students.filter(
          (studentObj) => studentObj.student.id === objId
        );
      } else if (level === "Class") {
        clonedPeriod.period.students = clonedPeriod.period.students.filter(
          (studentObj) => studentObj.student.classId === objId
        );
      }

      clonedPeriod.period.students.sort((a, b) => {
        const nameA = a.student.name.toUpperCase();
        const nameB = b.student.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });

      setPeriod(clonedPeriod);
      setActivePeriodId(navReducer.selectedAplPeriodId);
    }
  }, [
    navReducer.selectedAplPeriodId,
    periodsData.isLoading,
    periodsData.data,
    objId,
    level,
  ]);

  // Effect for setting currentPeriods
  useEffect(() => {
    if (!periodsData.isLoading) {
      setCurrentPeriods(periodsData.data);
    }
  }, [periodsData.data, periodsData.isLoading]);

  // Keep periodIdRef in sync with current period
  useEffect(() => {
    periodIdRef.current = period?.period?.id ?? null;
  }, [period]);

  // Effect for setting periodsToSelect dropdown options
  useEffect(() => {
    if (!periodsData.isLoading) {
      const tempSelectablePeriods = [];
      if (periodsData.data) {
        periodsData.data.forEach((periodItem) => {
          const dateFrom = new Date(periodItem.period.from);
          const dateTo = new Date(periodItem.period.to);
          const p = {
            value: periodItem.period.id,
            label:
              periodItem.period.name +
              (periodItem.period.id !== 0
                ? " - " +
                  dateFrom.toLocaleDateString("sv") +
                  " till " +
                  dateTo.toLocaleDateString("sv")
                : ""),
          };
          tempSelectablePeriods.push(p);
        });

        setPeriodsToSelect(tempSelectablePeriods);
      }
      if (periodIdRef.current !== null) {
        if (
          !tempSelectablePeriods.find((p) => p.value === periodIdRef.current)
        ) {
          setPeriod(null);
        }
      }
    }
  }, [periodsData.data, periodsData.isLoading]);

  return {
    period,
    setPeriod,
    activePeriodId,
    periodsToSelect,
    currentPeriods,
    setCurrentPeriods,
    selectedAplTab: navReducer.selectedAplTab,
  };
}
